'use client';

import { useClientTranslation } from '@lib/i18n/client';
import { ButtonGroup } from '@tuic/web-compositions/core/ButtonGroup';
import { TextButton } from '@tuic/web-compositions/core/TextButton';
import { AlertDialog } from '@tuic/web-compositions/shared/AlertDialog';
import { useState } from 'react';

import type { FC } from 'react';

type Props = {
  src: string;
};

/**
 * Non-production debug affordance: a "Show iframe URL" link in the dialog
 * footer that reveals the iframe's `src` (the same-origin portal route).
 * Mirrors `MxpDialogFooter` so the dev/QA experience is consistent across the
 * MXP and XiCafe iframes.
 */
export const XiCafePortalDialogFooter: FC<Props> = ({ src }) => {
  const { t } = useClientTranslation();
  const [urlVisible, setUrlVisible] = useState(false);

  return (
    <div className="px-4 flex items-center">
      <ButtonGroup>
        <TextButton onClick={() => setUrlVisible(true)}>
          {t('Iframe-URL anzeigen')}
        </TextButton>
      </ButtonGroup>
      <AlertDialog
        open={urlVisible}
        onOpenChange={() => setUrlVisible(false)}
        title={t('Iframe-URL des XiCafe-Dialogs')}
        actions={[{ title: t('Schließen') }]}
      >
        <div className="space-y-2">
          <code className="break-words">{src}</code>
        </div>
      </AlertDialog>
    </div>
  );
};
